<!-- MineRadio d43de565 public/index.html; Mineradio, GPL-3.0-only. -->
<template><span class="mineradio-icon" aria-hidden="true"><svg v-if="name === 'heart'" class="heart-svg"
              viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M12 21.45c-.32 0-.62-.12-.86-.34l-1.23-1.12C5.54 16.03 2.25 13.05 2.25 8.9 2.25 5.48 4.88 2.9 8.28 2.9c1.7 0 3.35.72 4.52 1.96C13.97 3.62 15.62 2.9 17.32 2.9c3.4 0 6.03 2.58 6.03 6 0 4.15-3.29 7.13-7.66 11.09l-1.23 1.12c-.24.22-.54.34-.86.34z" />
            </svg>
<svg v-if="name === 'plus'" width="18"
              height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M12 5v14" />
              <path d="M5 12h14" />
            </svg>
<svg v-if="name === 'repeat'"
              width="19" height="19" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M17 2l4 4-4 4" />
              <path d="M3 11V9a4 4 0 0 1 4-4h14" />
              <path d="M7 22l-4-4 4-4" />
              <path d="M21 13v2a4 4 0 0 1-4 4H3" />
            </svg>
<svg v-if="name === 'previous'" width="18" height="18"
              fill="currentColor" viewBox="0 0 24 24">
              <path d="M6 6h2v12H6zm3.5 6l8.5 6V6z" />
            </svg>
<svg v-if="name === 'play'" width="20"
              height="20" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
<svg v-if="name === 'next'" width="18" height="18"
              fill="currentColor" viewBox="0 0 24 24">
              <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" />
            </svg>
<svg v-if="name === 'queue'" width="19"
              height="19" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M8 6h13" />
              <path d="M8 12h13" />
              <path d="M8 18h13" />
              <path d="M3 6h.01" />
              <path d="M3 12h.01" />
              <path d="M3 18h.01" />
            </svg>
<svg v-if="name === 'volume'" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"
                viewBox="0 0 24 24">
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
                <path d="M15 9.5a4 4 0 0 1 0 5" />
              </svg>
<svg v-if="name === 'hide'"
              width="19" height="19" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M5 8h14" />
              <path d="M8 12h8" />
              <path d="M10 16h4" />
            </svg>
<svg v-if="name === 'immersive'" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.9"
              viewBox="0 0 24 24">
              <path d="M4 9V5a1 1 0 0 1 1-1h4" />
              <path d="M15 4h4a1 1 0 0 1 1 1v4" />
              <path d="M20 15v4a1 1 0 0 1-1 1h-4" />
              <path d="M9 20H5a1 1 0 0 1-1-1v-4" />
              <circle cx="12" cy="12" r="2.2" />
            </svg>
<svg v-if="name === 'fullscreen'" width="18"
              height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M3 7V3h4" />
              <path d="M21 7V3h-4" />
              <path d="M3 17v4h4" />
              <path d="M21 17v4h-4" />
            </svg><svg v-if="name === 'pause'" viewBox="0 0 24 24" fill="currentColor"><path d="M6 5h4v14H6zm8 0h4v14h-4z" /></svg></span></template>
<script>export default {name:'MineRadioIcon',props:{name:{type:String,required:true}}};</script>
<style scoped>.mineradio-icon{display:flex;align-items:center;justify-content:center;pointer-events:none}.mineradio-icon svg{width:21px;height:21px}</style>
